// import React, { useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import CollectionsSection from "../../Component/Home/CollectionsSection";
// import ServicesSection from "../../Component/Home/ServicesSection";
// import SafetySection from "../../Component/Home/SafetySection";
// import Slider from "./Landingpage/Sliderss";
// import Allinclusive from "./Allinclusive";

// const Landingpagess = () => {
//   const location = useLocation();

//   // Handle scrolling to different sections based on state
//   useEffect(() => {
//     const scrollToSection = (sectionId) => {
//       setTimeout(() => {
//         const element = document.getElementById(sectionId);
//         if (element) {
//           element.scrollIntoView({ 
//             behavior: 'smooth', 
//             block: 'start' 
//           });
//         }
//       }, 100);
//     };

//     if (location.state?.scrollToCollections) {
//       scrollToSection('collections-section');
//       window.history.replaceState({}, document.title);
//     }
    
//     if (location.state?.scrollToTestimonials) {
//       scrollToSection('testimonial-section');
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state]);

//   return (
//     <>
//       <Helmet>
//         <title>Custom Kitchen Cabinets New Jersey | Laminance Cabinetry</title>
//         <meta name="description" content="Premium custom kitchen cabinets, acrylic cabinets, and complete kitchen renovation services in New Jersey. Free consultation and professional installation." />
//         <link rel="canonical" href="https://laminance.com" />
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content="https://laminance.com" />
//         <meta property="og:title" content="Custom Kitchen Cabinets New Jersey | Laminance Cabinetry" />
//         <meta property="og:description" content="Premium custom kitchen cabinets and complete kitchen renovation services in New Jersey." />
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:title" content="Custom Kitchen Cabinets New Jersey | Laminance Cabinetry" />
//         <meta name="twitter:description" content="Premium custom kitchen cabinets and complete kitchen renovation services in New Jersey." />
//       </Helmet>

//       <main>
//         <section aria-label="Hero slider with kitchen transformations">
//           <Slider />
//         </section>

//         <section aria-label="All-inclusive kitchen transformation package">
//           <Allinclusive />
//         </section>

//         <section id="collections-section" aria-label="Kitchen cabinet collections gallery">
//           <CollectionsSection />
//         </section>

//         <section aria-label="Our kitchen services">
//           <ServicesSection />
//         </section>

//         <section id="testimonial-section" aria-label="Customer testimonials and safety information">
//           <SafetySection />
//         </section>
//       </main>
//     </>
//   );
// };

// export default Landingpagess;




import React, { useEffect } from "react";
import { useLocation, useOutletContext } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import CollectionsSection from "../../Component/Home/CollectionsSection";
import ServicesSection from "../../Component/Home/ServicesSection";
import SafetySection from "../../Component/Home/SafetySection";
import Slider from "./Landingpage/Sliderss";
import Allinclusive from "./Allinclusive";

const Landingpagess = () => {
  const location = useLocation();
  const { openVideoModal } = useOutletContext();

  // Handle scrolling to different sections based on state
  useEffect(() => {
    const scrollToSection = (sectionId) => {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        }
      }, 100);
    };

    if (location.state?.scrollToCollections) {
      scrollToSection('collections-section');
      window.history.replaceState({}, document.title);
    }
    
    if (location.state?.scrollToTestimonials) {
      scrollToSection('testimonial-section');
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <>
      <Helmet>
        <title>Custom Kitchen Cabinets New Jersey | Laminance Cabinetry</title>
        <meta name="description" content="Premium custom kitchen cabinets, acrylic cabinets, and complete kitchen renovation services in New Jersey. Free consultation and professional installation." />
        <link rel="canonical" href="https://laminance.com" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://laminance.com" />
        <meta property="og:title" content="Custom Kitchen Cabinets New Jersey | Laminance Cabinetry" />
        <meta property="og:description" content="Premium custom kitchen cabinets and complete kitchen renovation services in New Jersey." />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Custom Kitchen Cabinets New Jersey | Laminance Cabinetry" />
        <meta name="twitter:description" content="Premium custom kitchen cabinets and complete kitchen renovation services in New Jersey." />
      </Helmet>

      <main>
        <section aria-label="Hero slider with kitchen transformations">
          <Slider />
        </section>

        <section aria-label="All-inclusive kitchen transformation package">
          <Allinclusive />
        </section>

        <section id="collections-section" aria-label="Kitchen cabinet collections gallery">
          <CollectionsSection onVideoClick={openVideoModal} />
        </section>

        <section aria-label="Our kitchen services">
          <ServicesSection />
        </section>

        <section id="testimonial-section" aria-label="Customer testimonials and safety information">
          <SafetySection />
        </section>
      </main>
    </>
  );
};

export default Landingpagess;